module.exports = __webpack_public_path__ + "img/fm.52a2b610.svg";